import axios from "axios";
import { DataUploadProcess } from "./types";

export const dataUploadProcess = async (props: DataUploadProcess) => {
  try {
    const response = await axios.post(
      `${process.env.REACT_APP_PROXY_URL}/v1/upload/process`,
      {
        action: "process",
        compound_number: props.compound,
        protocol_number: props.protocol,
        transfer_id: props.transferId,
        environment: props.environment,
        file_count: props.fileCount,
        all_files: props.fileNames,
        record_id: props.recordId,
        is_data_format: props.isDataFormat,
        is_offline_flow: props.isOfflineFlow,
      },
      {
        headers: {
          Authorization: "Basic " + process.env.REACT_APP_AUTHORIZATION_KEY,
          "x-merck-apikey": process.env.REACT_APP_X_MERCK_API_KEY,
        },
      },
    );
    return response.data;
  } catch (e: any) {
    const message =
      e?.response?.data?.message ||
      e?.response?.data?.error ||
      e?.message ||
      "Failed to process upload files.";
    return { error: true, message };
  }
};
